import { GetApplicationInterviewsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useApplicationInterviews = (atsApplicationId: number) => {
  const { data, loading } = useQuery(GetApplicationInterviewsDocument, {
    variables: { atsApplicationId },
  })

  return {
    loading,
    interviews: data?.ats.interviewsConnection.nodes,
  }
}
